import type { PaginationProps as AntdPaginationProps } from 'antd';
import { Pagination as AntdPagination } from 'antd';

interface PaginationProps {
    page: number;
    totalPages: number;
    setPage: (value: number) => void;
    setPageSize?: (value: number) => void;
    pageSize?: number;
}

const Pagination = ({ page, totalPages, pageSize = 20, setPage, setPageSize }: PaginationProps) => {
    const onChange: AntdPaginationProps['onChange'] = (page, pageSize) => {
        setPage(page);
        setPageSize(pageSize);
    };

    return(
        <AntdPagination 
            defaultCurrent={page}
            total={totalPages}
            pageSize={pageSize}
            onChange={onChange}
        />
    )
}

export { Pagination }